export default __webpack_public_path__ + "static/media/Aflac dark.2a253fa6.svg";